<template>
  <div v-show="configInfo && configInfo.crossmodal && configInfo.crossmodal == 1" class="aiMessage">
    <div @click="toggleShowContent" v-if="!showContent" class="aiMessageIcon">

    </div>
    <div v-else class="aiMessage-content">
      <div class="head">
        <div class="l">
          <div class="icon"></div>
          <div class="title">AI高级检索</div>
        </div>
        <div class="r">
          <div v-show="!showHistory" @click="getSearchlog();showHistory = true" class="history"></div>
          <div @click="toggleShowContent" class="close"></div>
        </div>
      </div>
      <div ref="searchResultDom" @scroll="calcTop" v-show="!showHistory && !showQuestion" class="content">
        <div class="tipsContent">
          <div class="t"><span><span>{{configInfo.greeting && configInfo.greeting[0].desc}}</span></span>{{configInfo.greeting && configInfo.greeting[1].desc}}
          </div>
          <div class="b">{{configInfo.greeting && configInfo.greeting[2].desc}}</div>
        </div>
        <div class="likeContent">
          <div class="title">你可以尝试</div>
          <div class="likebox">
            <ul>
              <li @click="topSearch(item.content)" v-for="(item, index) in configInfo && configInfo.recommend && configInfo.recommend.list" :key="item.id">
                <i :class="index%2 == 0 ? 'icon1' : 'icon2'"></i>
                <p>{{item.content}}</p>
              </li>
            </ul>
          </div>
        </div>

        <template v-for="(item,index) in searchList">
          <div v-if="item.type == 'input'" class="user">
            <p>{{item.value}}</p>
          </div>
          <div v-else-if="item.type == 'search'" class="agent">
            <p class="search">正在拼命寻找中…</p>
          </div>
          <!-- <div class="fav">
            <div class="title">推荐</div>
            <div class="fav-list">
              <p class="on">
                <i class="origin"></i>
                <span>仅搜索原创内容</span>
              </p>
              <p>
                <i class="full"></i>
                <span>请帮我全局搜索</span>
              </p>
            </div>
          </div> -->
          <div v-else-if="item.type == 'result' && item.res.list.length > 0" class="result">
            <div class="title">以下是Xnews中和<span>{{"“"+item.title+"”"}}</span>相关的素材：</div>
            <div class="content">
              <ul>
                <li @click="openDetail(items, item.title)" v-show="index < 5" v-for="(items, index) in item.res.list">
                  <i :class="{audio: items.type == 3,pic: items.type == 1,video: items.type == 2, doc: items.type == 4}"></i>
                  <p :title="items.title" v-html="items.title"></p>
                  <span v-show="Number(val.score) > 0" v-for="val in items.search_hit">{{val.desc}}</span>
                </li>
              </ul>
            </div>
            <div class="btns">
              <div class="l">
                <div @click="$AiMaterial({type: 'more',title: item.title})" v-show="item.res.list.length > 5" class="star"></div>
                <span @click="$AiMaterial({type: 'more',title: item.title})" v-show="item.res.list.length > 5">检索更多...</span>
              </div>
              <div class="r">
                <div @click="keyword=item.title;submitFeedback(1);item.isZan = true" :class="{zan: true,on: item.isZan}"></div>
                <div @click="keyword=item.title;showQuestion = true" class="cai"></div>
              </div>
            </div>
          </div>

          <div v-if="item.type == 'result' && item.res.list.length < 5" class="noSearch">
            <i></i>
            <p>当前检索结果较少，建议尝试寻找 <span v-if="item.res.search_option && item.res.search_option.length > 0" @click="topSearch(items)" v-for="items in item.res.search_option">{{items}}</span><span style="font-style: normal;color: #050F0F;text-decoration: none;cursor: normal;" v-if="item.res.search_option.length == 0">其他关键词</span></p>
          </div>
        </template>
      </div>
      <div v-show="!showHistory && !showQuestion" class="foot">
        <!-- <div class="voice"></div> -->
        <div class="input">
          <input @keydown.enter="search" maxlength="255" v-model="searchContent" placeholder="请输入检索的关键词" type="text">
          <div @click="search" class="search"></div>
        </div>
        <!-- <div class="stop">
          <i class="del"></i>
          <span>停止搜索</span>
        </div> -->
        <div @click="$AiMaterial({type: 'history'})" class="current">近期查看</div>
      </div>

      <div v-show="showHistory" class="historyContent">
        <div class="title">
          <div @click="showHistory = false" class="back"></div>
          <span>历史记录</span>
        </div>
        <div ref="list" @scroll="getScroll($event)" class="content">
          <div class="title">
            <p>以下是90天内的检索记录：</p>
          </div>

          <ul>
            <li>
              <p>本周</p>
              <ul>
                <li @click="topSearch(item.title);showHistory = false" v-for="item in history.week" :key="item.id"><i></i><p>{{item.title}}</p></li>
              </ul>
            </li>
            <li>
              <p>七天前</p>
              <ul>
                <li @click="topSearch(item.title);showHistory = false" v-for="item in history.sevenDayAgo && history.sevenDayAgo.list" :key="item.id"><i></i><p>{{item.title}}</p></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <div v-show="showQuestion && !isSubmit" class="questionContent">
        <div class="title">
          <span>请问不满意的原因是？</span>
        </div>

        <div class="content">
          <ul class="questionBtns">
            <li v-for="(item, index) in configInfo.feedback" @click="item.selected = !item.selected" :key="index" :class="{on: item.selected}">{{item.title}}</li>
          </ul>

          <div class="questionTextarea">
            <div class="t">
              <i></i>
              <span>请留下具体的原因或建议：</span>
            </div>
            <textarea v-model="suggestion" maxlength="200" placeholder="感谢您的时间！您的反馈能帮助我们更好地改进产与服务，提升更多用户的使用体验。"></textarea>
            <div class="btns">
              <div @click="submitFeedback(0)" class="btn on">提交</div>
              <div @click="showQuestion = false" class="btn">取消</div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="showQuestion && isSubmit" class="fallbackContent">
        <div class="content">
          <img src="./assets/bigStar.png" alt="">
          <p>
            <span>感谢您的反馈</span>
          </p>
          <span class="txt">我们会努力改进产品服务，提升用户体验期待您的认可</span>
          <div @click="showQuestion = false;isSubmit = false;" class="btn">返回</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import * as config from "@common/config";
import store from "@common/store";
import Upload from '@common/newUpload'

export default {
  name: 'aiMessage',
  data() {
    return {
      scrollInterval: null,
      keyword: '',
      showContent: false,
      feedBackIndex: 0,
      history: {},
      show: false,
      r: null,
      showHistory: false,
      showQuestion: false,
      isSubmit: false,
      configInfo: {},
      searchContent: '',
      pages: {
        pageIndex: 1
      },
      searchList: [],
      reason_types: [],
      suggestion: '',
      scrollTop: 0,
      noMore: false
    }
  },
  methods: {
    calcTop(e) {
      // console.log(e)
      this.scrollTop = e.target.scrollTop
    },
    toggleShowContent() {
      // if(this.showContent){
      //   this.scrollTop = this.$refs.searchResultDom.scrollHeight
      //   console.log(this.$refs.searchResultDom.scrollHeight)
      // }

      this.showContent = !this.showContent;

      if(this.showContent){
        this.$nextTick(() => {
          this.$refs.searchResultDom.scrollTop = this.scrollTop;
        })
      }
    },
    openDetail(detail, title) {
      let data = {
        type: detail.type,
        id: detail.id,
        create: store.state.create,
        canEdit: false,
        quickEdit: store.state.quickEdit,
        keywords: title,
        search_from: 'bubble',
        search_hit: JSON.stringify(detail.search_hit),
        vector_result: detail.vector_result
      };
      this.$materialBox(data);
    },
    submitFeedback(is_satisfied) {
      let reason_types = []

      this.configInfo.feedback.forEach(el => {
        if(el.selected){
          reason_types.push(el.id)
        }
      })

      let info = {
        is_satisfied: is_satisfied,
        keyword: this.keyword,
        reason_types: reason_types.join(','),
        suggestion: this.suggestion
      }
      common.myFetch(config.apis.submitFeedback,info).then(r => {
        if (r) {
          this.configInfo.feedback.forEach(el => {
            el.selected = false
          })
          this.suggestion = ''
          if(is_satisfied == 0){
            this.isSubmit = true
          }
        }
      });
    },
    topSearch(searchContent) {
      this.searchList.push({
        type: 'input',
        value: searchContent
      })

      this.searchList.push({
        type: 'search'
      })

      let info = {
        key_words: searchContent,
        search_from: 'bubble',
        search_model: 3,
        page_type: 'file'
      }
      common.myFetch(config.apis.fileList,info).then(r => {
        if (r) {
          if(r.list){
            this.searchList.push({
              type: 'result',
              res: r,
              title: searchContent,
              isZan: false
            })
          }

          this.$nextTick(() => {
            this.$refs.searchResultDom.scrollTop = this.$refs.searchResultDom.scrollHeight;
          })
          
          console.log(r)
        }
      });
    },
    search() {
      let searchContent = this.searchContent
      if(!this.searchContent){
        this.$toast('请输入检索关键词')
        return false;
      }
      this.searchList.push({
        type: 'input',
        value: searchContent
      })

      this.searchList.push({
        type: 'search'
      })

      let info = {
        key_words: searchContent,
        search_from: 'bubble',
        search_model: 3,
        page_type: 'file'
      }
      this.searchContent = ''
      common.myFetch(config.apis.fileList,info).then(r => {
        if (r) {
          if(r.list){
            this.searchList.push({
              type: 'result',
              res: r,
              title: searchContent,
              isZan: false
            })
          }
          this.$nextTick(() => {
            this.$refs.searchResultDom.scrollTop = this.$refs.searchResultDom.scrollHeight;
          })
        }
      });
    },
    open(c, r) {
      this.r = r
      this.show = true
      this.getConfig()
    },
    close() {
      this.show = false
    },
    getConfig() {
      common.myFetch(config.apis.indexConfig).then(r => {
        if (r) {
          r.feedback.forEach(el => {
            el.selected = false
          })
          this.configInfo = r
          console.log(r)
        }
      });
    },
    getViewHistory() {
      common.myFetch(config.apis.viewhistory).then(r => {
        if (r) {
          console.log(r)
        }
      });
    },
    getSearchlog() {
      let info = {
        page: this.pages.pageIndex,
        pagesize: 10
      }
      common.myFetch(config.apis.searchlog,info).then(r => {
        if (r) {
          console.log(r)
          if(this.pages.pageIndex == 1){
            this.history = r
          }else{
            let list = this.history.sevenDayAgo.list;
            if(r.sevenDayAgo.list.length == 0){
              this.noMore = true
            }
            list = list.concat(r.sevenDayAgo.list)
            r.sevenDayAgo.list = list;
            this.history = r;
          }
        }
      });
    },
    async getScroll(e) {
      if (e) {
        if(this.scrollInterval){
          clearTimeout(this.scrollInterval)
          this.scrollInterval = null
        }

        this.scrollInterval = setTimeout(() => {
          let containerH = 482;
          let scrollTop = e.target.scrollTop;
          let listHeight = this.$refs.list.offsetHeight;
          console.log("getScroll");
          if (scrollTop + containerH >= listHeight && !this.noMore) {
            this.pages.pageIndex ++
            console.log("getScroll 拿分页");
            this.getSearchlog()
          }
        },300)
      }
    }
  },
  mounted() {
    // this.$AiMaterial()
  },
  created() {

  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .aiMessage {
    position: fixed;
    z-index: 9999;
    top: 90px;
    right: 20px;
    width: 320px;

    .aiMessageIcon {
      position: fixed;
      bottom: 240px;
      right: 14px;
      width: 59px;
      height: 64px;
      background: url('./assets/logoIcon.png') no-repeat;
      background-color: rgba(185,195,195,0.4);
      background-position: center center;
      background-size: 44px 44px;
      border-radius: 50%;
      overflow: hidden;
      user-select: none;
      cursor: pointer;

      &:hover {
        width: 59px;
        height: 64px;
        background: url('./assets/logoIconOn.png') no-repeat;
        background-color: #41B48C;
        background-position: center center;
        background-size: 44px 44px;
      }
    }

    .aiMessage-content {
      position: fixed;
      bottom: -14px;
      right: -14px;
      display: flex;
      flex-direction: column;
      width: 420px;
      height: 600px;
      background: url('./assets/bg.png') no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      padding: 6px 14px 14px 6px;
      box-sizing: border-box;

      .head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 50px;
        background: linear-gradient( 180deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.13) 100%);
        box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
        border-radius: 12px 12px 0px 0px;
        backdrop-filter: blur(10px);
        padding: 0 20px;
        box-sizing: border-box;

        .l {
          display: flex;
          align-items: center;

          .icon {
            display: block;
            width: 22px;
            height: 22px;
            background: url('./assets/icon.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-right: 6px;
          }
  
          .title {
            font-size: 16px;
            color: #050F0F;
            font-weight: bold
          }
        }

        .r {
          display: flex;
          align-items: center;

          .history {
            width: 20px;
            height: 20px;
            background: url('./assets/history.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            user-select: none;
            cursor: pointer;
          }

          .close {
            width: 20px;
            height: 20px;
            background: url('./assets/sq.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-left: 10px;
            user-select: none;
            cursor: pointer;
          }
        }
      }

      & > .content {
        flex: 1;
        min-height: 0;
        width: 100%;
        overflow-y: auto;
        padding: 14px 20px 48px;
        box-sizing: border-box;

          &::-webkit-scrollbar {
              width: 4px;
          }
          &::-webkit-scrollbar-thumb {
              background: #ddd;
              border-radius: 4px;
          }

        .tipsContent {
          display: flex;
          flex-direction: column;
          width: 100%;
          padding: 16px 20px;
          box-sizing: border-box;
          box-shadow: 0px 9px 28px 0px rgba(0,0,0,0.05), 0px 6px 16px -8px rgba(0,0,0,0.2);
          border-radius: 12px;
          background: rgba(255,255,255,0.8);
          margin-bottom: 20px;

          .t {
            padding-bottom: 10px;
            border-bottom: 1px solid #DDDFE7;
            box-sizing: border-box;
            font-weight: bold;
            font-size: 16px;
            color: #050F0F;
            line-height: 24px;

            & > span {
              position: relative;
              
              & > span {
                position: relative;
                z-index: 2;
              }

              &:before {
                display: block;
                content: '';
                position: absolute;
                z-index: 1;
                bottom: 0;
                left: 0;
                width: -webkit-fill-available;
                height: 6px;
                background: #80DABB;
              }
            }
          }

          .b {
            font-weight: 500;
            font-size: 13px;
            color: #050F0F;
            line-height: 21px;
            margin-top: 9px;
          }
        }

        .likeContent {
          display: flex;
          flex-direction: column;
          margin-bottom: 20px;

          .title {
            font-weight: bold;
            font-size: 16px;
            color: #050F0F;
            line-height: 24px;
            margin-bottom: 10px;
          }

          .likebox {
            width: 100%;
            padding: 14px;
            box-shadow: 0px 9px 28px 0px rgba(0,0,0,0.05), 0px 6px 16px -8px rgba(0,0,0,0.2);
            border-radius: 12px;
            box-sizing: border-box;
            background: #FFF;

            ul {
              display: flex;
              flex-direction: column;
              width: 100%;

              li {
                display: flex;
                align-items: center;
                width: 100%;
                height: 40px;
                background: #F3F5F7;
                border-radius: 12px;
                margin-bottom: 10px;
                padding: 0 10px;
                box-sizing: border-box;
                user-select: none;
                cursor: pointer;

                &:nth-last-of-type(1) {
                  margin-bottom: 0;
                }

                .icon1 {
                  width: 20px;
                  height: 20px;
                  background: url('./assets/icon1.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                  margin-right: 6px;
                }

                .icon2 {
                  width: 20px;
                  height: 20px;
                  background: url('./assets/icon2.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                  margin-right: 6px;
                }

                p {
                  flex: 1;
                  min-width: 0;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  font-weight: 500;
                  font-size: 13px;
                  color: #050F0F;
                }
              }
            }
          }
        }

        .user {
          display: flex;
          justify-content: flex-end;
          width: 100%;
          margin-bottom: 20px;

          p {
            padding: 9px 14px;
            box-sizing: border-box;
            background: #29B785;
            border-radius: 12px 12px 0px 12px;
            font-weight: 500;
            font-size: 13px;
            color: #FFFFFF;
            line-height: 22px;
          }
        }

        .agent {
          display: flex;
          justify-content: flex-start;
          width: 100%;
          margin-bottom: 20px;

          p {
            display: flex;
            align-items: center;
            padding: 9px 14px;
            box-sizing: border-box;
            background: rgba(255,255,255,0.8);
            box-shadow: 0px 9px 28px 0px rgba(0,0,0,0.05), 0px 6px 16px -8px rgba(0,0,0,0.2);
            border-radius: 12px;
            font-weight: 500;
            font-size: 13px;
            color: #050F0F;
            line-height: 22px;

            &.search {
              &::before {
                display: inline-flex;
                content: '';
                width: 20px;
                height: 20px;
                background: url('./assets/searchIcon.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 6px;
              }
            }
          }
        }

        .fav {
          display: flex;
          flex-direction: column;
          margin-bottom: 20px;

          .title {
            font-weight: bold;
            font-size: 16px;
            color: #050F0F;
            line-height: 24px;
            margin-bottom: 10px;
          }

          .fav-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 68px;
            background: rgba(255,255,255,0.8);
            box-shadow: 0px 9px 28px 0px rgba(0,0,0,0.05), 0px 6px 16px -8px rgba(0,0,0,0.2);
            border-radius: 12px;
            padding: 0 14px;
            box-sizing: border-box;

            p {
              display: flex;
              align-items: center;
              width: 160px;
              height: 40px;
              background: #F3F5F7;
              border-radius: 12px;
              border: 1px solid transparent;
              box-sizing: border-box;
              font-weight: 500;
              font-size: 13px;
              color: #050F0F;
              padding: 0 10px;
              box-sizing: border-box;
              user-select: none;
              cursor: pointer;

              .origin {
                display: block;
                width: 20px;
                height: 20px;
                background: url('./assets/icon3.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 6px;
              }

              .full {
                display: block;
                width: 20px;
                height: 20px;
                background: url('./assets/icon2.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 6px;
              }

              &.on {
                border: 1px solid #41B48C;
                box-sizing: border-box;
              }
            }
          }
        }

        .result {
          width: 100%;
          padding: 14px 20px;
          box-sizing: border-box;
          box-shadow: 0px 9px 28px 0px rgba(0,0,0,0.05), 0px 6px 16px -8px rgba(0,0,0,0.2);
          border-radius: 12px;
          background: rgba(255,255,255,0.8);

          .title {
            font-weight: 500;
            font-size: 13px;
            color: #050F0F;
            line-height: 21px;
            padding-bottom: 10px;
            border-bottom: 1px solid #DDDFE7;
            box-sizing: border-box;

            span {
              &::after {
                display: inline-block;
                content: '、';
              }

              &:nth-last-of-type(1) {
                &::after {
                  display: none;
                  content: '、';
                }
              }
            }
          }

          .content {
            width: 100%;
            padding: 10px 0;
            border-bottom: 1px solid #DDDFE7;
            box-sizing: border-box;

            ul {
              width: 100%;
              display: flex;
              flex-direction: column;

              li {
                display: flex;
                align-items: center;
                width: 100%;
                margin-bottom: 18px;
                user-select: none;
                cursor: pointer;

                &:nth-last-of-type(1) {
                  margin-bottom: 0;
                }

                .audio {
                  display: block;
                  width: 20px;
                  min-width: 20px;
                  height: 20px;
                  background: url('./assets/audio.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                  margin-right: 10px;
                }

                .doc {
                  display: block;
                  width: 20px;
                  min-width: 20px;
                  height: 20px;
                  background: url('./assets/doc.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                  margin-right: 10px;
                }

                .video {
                  display: block;
                  width: 20px;
                  min-width: 20px;
                  height: 20px;
                  background: url('./assets/video.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                  margin-right: 10px;
                }

                .pic {
                  display: block;
                  width: 20px;
                  min-width: 20px;
                  height: 20px;
                  background: url('./assets/pic.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                  margin-right: 10px;
                }

                p {
                  max-width: calc(100% - 104px);
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  font-weight: 500;
                  font-size: 13px;
                  color: #050F0F;

                  em {
                    color: #41B48C;
                    font-style: normal;
                  }

                  &:hover {
                    color: #41B48C;
                  }
                }

                span {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  white-space: nowrap;
                  height: 18px;
                  border-radius: 10px;
                  border: 1px solid #41B48C;
                  font-weight: 500;
                  font-size: 12px;
                  color: #41B48C;
                  margin-left: 10px;
                  padding: 0 8px;
                  box-sizing: border-box;

                  &:nth-last-of-type(1) {
                    margin-right: 0;
                  }
                }
              }
            }
          }

          .btns {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding-top: 14px;
            box-sizing: border-box;

            .l {
              display: flex;
              align-items: center;
              user-select: none;
              cursor: pointer;

              .star {
                display: block;
                width: 20px;
                height: 20px;
                background: url('./assets/star.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 6px;
              }

              span {
                font-weight: bold;
                font-size: 13px;
                color: #41B48C;
                text-decoration-line: underline;
              }
            }

            .r {
              display: flex;
              align-items: center;

              .zan {
                display: block;
                width: 20px;
                height: 20px;
                background: url('./assets/zan.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 14px;
                user-select: none;
                cursor: pointer;

                &:hover {
                  width: 20px;
                  height: 20px;
                  background: url('./assets/zanOn.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                }

                &.on {
                  width: 20px;
                  height: 20px;
                  background: url('./assets/zanOn.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                }
              }

              .cai {
                display: block;
                width: 20px;
                height: 20px;
                background: url('./assets/cai.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 14px;
                user-select: none;
                cursor: pointer;

                &:hover {
                  width: 20px;
                  height: 20px;
                  background: url('./assets/caiOn.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                }
              }
            }
          }
        }

        .noSearch {
          display: flex;
          margin: 14px 0 20px;

          i {
            display: block;
            width: 20px;
            height: 20px;
            min-width: 20px;
            background: url('./assets/searchIcon.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-right: 6px;
          }

          p {
            display: flex;
            flex-wrap: wrap;
            font-weight: 500;
            font-size: 13px;
            color: #050F0F;
            line-height: 22px;

            span {
              color: #41B48C;
              text-decoration: underline;
              user-select: none;
              cursor: pointer;

              &:nth-last-of-type(1) {
                &::after {
                  display: none;
                }
              }

              &::after {
                display: inline-flex;
                content: '、';
              }
            }
          }
        }
      }

      .foot {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 64px;
        background: #FFFFFF;
        border-radius: 0px 0px 12px 12px;
        padding: 0 10px 0 14px;
        box-sizing: border-box;

        .voice {
          width: 28px;
          height: 28px;
          background: url('./assets/voice.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          margin-right: 14px;
          user-select: none;
          cursor: pointer;
        }

        .input {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex: 1;
          min-width: 0;
          height: 44px;
          border-radius: 12px;
          background: #F6F8FB;
          padding: 0 20px;
          box-sizing: border-box;

          input {
            flex: 1;
            min-width: 0;
            height: 100%;
            background: transparent;

            &::placeholder {
              color: #B9C3C3;
            }
          }

          .search {
            width: 28px;
            height: 28px;
            background: url('./assets/search.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            user-select: none;
            cursor: pointer;
            margin-left: 10px;
          }
        }

        .current {
          position: absolute;
          z-index: 9;
          right: 20px;
          top: -44px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 72px;
          height: 30px;
          background: rgba(231,232,233,1);
          border-radius: 8px;
          user-select: none;
          cursor: pointer;
          font-weight: 500;
          font-size: 13px;
          line-height: 30px;
          color: #050F0F;
        }

        .stop {
          position: absolute;
          z-index: 9;
          left: 20px;
          top: -44px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 92px;
          height: 30px;
          background: rgba(249,231,232,1);
          border-radius: 8px;
          user-select: none;
          cursor: pointer;

          .del {
            display: block;
            width: 14px;
            height: 14px;
            background: url('./assets/del.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-right: 6px;
          }

          span {
            font-weight: 500;
            font-size: 13px;
            line-height: 30px;
            color: #050F0F;
          }
        }
      }

      .historyContent {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        width: 100%;
        padding: 14px 20px 0 20px;
        box-sizing: border-box;

        & > .title {
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #050F0F;
          font-weight: bold;
          line-height: 24px;
          margin-bottom: 10px;

          .back {
            width: 16px;
            height: 16px;
            background: url('./assets/back.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            user-select: none;
            cursor: pointer;
            margin-right: 16px;
          }
        }

        & > .content {
          flex: 1;
          min-height: 0;
          width: 100%;
          background: rgba(255,255,255,0.8);
          box-shadow: 0px 9px 28px 0px rgba(0,0,0,0.05), 0px 6px 16px -8px rgba(0,0,0,0.2);
          border-radius: 12px;
          padding: 14px 14px 0 14px;
          box-sizing: border-box;
          overflow-y: auto;

          &::-webkit-scrollbar {
            width: 4px;
          }
          &::-webkit-scrollbar-thumb {
              background: #ddd;
              border-radius: 4px;
          }

          .title {
            padding: 0 6px 0px 6px;
            box-sizing: border-box;
            font-weight: 500;
            font-size: 13px;
            color: #050F0F;
            line-height: 21px;
            margin-bottom: 11px;

            p {
              padding-bottom: 14px;
              border-bottom: 1px solid #DDDFE7;
              box-sizing: border-box;
              font-weight: 500;
              font-size: 13px;
              color: #050F0F;
              line-height: 21px;
            }
          }

          & > ul {
            display: flex;
            flex-direction: column;
            width: 100%;

            & > li {
              display: flex;
              flex-direction: column;
              margin-bottom: 12px;

              & > p {
                font-weight: 500;
                font-size: 13px;
                color: #050F0F;
                line-height: 21px;
                margin-bottom: 12px;
              }

              ul {
                display: flex;
                flex-direction: column;
                width: 100%;

                li {
                  display: flex;
                  align-items: center;
                  flex-wrap: nowrap;
                  width: 100%;
                  height: 40px;
                  background: #F3F5F7;
                  border-radius: 12px;
                  margin-bottom: 10px;
                  padding: 0 12px;
                  box-sizing: border-box;
                  font-weight: 500;
                  font-size: 13px;
                  color: #050F0F;
                  user-select: none;
                  cursor: pointer;

                  p {
                    flex: 1;
                    min-width: 0;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }

                  i {
                    display: inline-flex;
                    content: '';
                    width: 8px;
                    height: 8px;
                    background: #41B48C;
                    border-radius: 50%;
                    margin-right: 12px;
                  }

                  &:nth-last-of-type(1) {
                    margin-bottom: 0;
                  }
                }
              }
            }
          }
        }
      }

      .questionContent {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        width: 100%;
        padding: 14px 20px 0 20px;
        box-sizing: border-box;

        .title {
          font-weight: bold;
          font-size: 16px;
          color: #050F0F;
          line-height: 24px;
          margin-bottom: 10px;
        }

        .content {
          width: 100%;
          height: 432px;
          background: #FFFFFF;
          box-shadow: 0px 9px 28px 0px rgba(0,0,0,0.05), 0px 6px 16px -8px rgba(0,0,0,0.2);
          border-radius: 12px;
          padding: 14px 14px 24px;
          box-sizing: border-box;

          .questionBtns {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            border-bottom: 1px solid #DDDFE7;
            box-sizing: border-box;

            li {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 161px;
              height: 40px;
              background: #F3F5F7;
              border-radius: 12px;
              margin-bottom: 10px;
              font-weight: 500;
              font-size: 13px;
              color: #050F0F;
              border: 1px solid transparent;
              box-sizing: border-box;
              user-select: none;
              cursor: pointer;

              &.on {
                border: 1px solid #41B48C;
                box-sizing: border-box;
              }
            }
          }

          .questionTextarea {
            width: 100%;
            flex: 1;
            min-height: 0;
            padding-top: 9px;
            box-sizing: border-box;

            .t {
              display: flex;
              align-items: center;
              margin-bottom: 10px;

              i {
                display: block;
                width: 20px;
                height: 20px;
                background: url('./assets/icon4.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 4px;
              }

              span {
                font-weight: 500;
                font-size: 13px;
                color: #050F0F;
                line-height: 21px;
              }
            }

            textarea {
              width: 100%;
              height: 148px;
              background: #F6F8FB;
              border-radius: 12px;
              resize: none;
              padding: 14px 20px;
              box-sizing: border-box;
              margin-bottom: 24px;

              &::placeholder {
                font-size: 14px;
                line-height: 21px;
                color: #B9C3C3;
              }
            }

            .btns {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;

              .btn {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 120px;
                height: 32px;
                background: #B9C3C3;
                border-radius: 4px;
                font-size: 14px;
                color: #FFFFFF;
                font-weight: bold;
                user-select: none;
                cursor: pointer;

                &.on {
                  background: #41B48C;
                  margin-right: 20px;
                }
              }
            }
          }
        }
      }

      .fallbackContent {
        flex: 1;
        min-height: 0;
        width: 100%;
        padding: 20px;
        box-sizing: border-box;

        .content {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          height: 432px;
          background: rgba(255,255,255,0.8);
          box-shadow: 0px 9px 28px 0px rgba(0,0,0,0.05), 0px 6px 16px -8px rgba(0,0,0,0.2);
          border-radius: 12px;

          img {
            width: 64px;
            height: 64px;
            margin-top: 60px;
            margin-bottom: 20px;
          }

          p {
            position: relative;

            span {
              position: relative;
              font-weight: bold;
              font-size: 16px;
              color: #050F0F;
              line-height: 24px;
              z-index: 2;
            }

            &::before {
              display: block;
              content: '';
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 1;
              width: 100px;
              height: 6px;
              background: #80DABB;
            }
          }

          & > span {
            width: 235px;
            text-align: center;
            font-weight: 500;
            font-size: 13px;
            color: #050F0F;
            line-height: 21px;
            margin-top: 14px;
            margin-bottom: 66px;
          }

          .btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 188px;
            height: 32px;
            background: #41B48C;
            border-radius: 4px;
            font-weight: bold;
            font-size: 14px;
            color: #FFFFFF;
            user-select: none;
            cursor: pointer;
          }
        }
      }


    }
  }

  @keyframes translateXShow {
    0% {
      transform: translateX(350px);
    }

    100% {
      transform: translateX(10px);
    }
  }
</style>

<style lang="less">
  .aiMessage {

    em {
      color: #41B48C;
      font-style: normal;
    }
  }

  @keyframes translateXShow {
    0% {
      transform: translateX(350px);
    }

    100% {
      transform: translateX(10px);
    }
  }
</style>
